<template>
  <div class="layout-box">
    <div class="head-wh">
      <div class="title-center"><span>{{ headtitle }}</span></div>
     <AccountInfo :keepalives="kls" ></AccountInfo><!-- :permissions="permissions"-->
    </div>
    <div class="secondary-content">
      <div class="pdwk-l">
        <div class="pdwk-l-t">
          <div style="height: 100%; width: 420px; display: inline-block; padding: 15px 10px 5px 15px; box-sizing: border-box">
            <Echartring :configs="myconfigring4" ref="myconfigring4"></Echartring>
          </div>
          <div style="display: inline-block; width: 420px; height: 100%; vertical-align: bottom">
            <h3 style="text-align: center; color: #F4F7FF ; font-size: 19px; padding-top: 10px">本月设备维修订单</h3>
            <div class="clinch-deal-list">
              <p><span>#</span><span>设备</span><span>维修原因</span><span>状态</span></p>
              <ul>
                <vue-seamless-scroll :data="workAll.repairList" :class-option="classOption" class="seamless-warp">
                  <li v-for="(item,index) in workAll.repairList" :key="index"><span><em>{{ index+1 }}</em></span><span :title="item.equipmentname">{{ item.equipmentname }}</span><span :title="item.faultdescription">{{ item.faultdescription }}</span><span><el-button :type="item.docstatus*1>1?(item.docstatus*1>2?'info':'success'):'primary'" size="mini" plain>{{ item.docstatus | maintenances }}</el-button></span></li>
                </vue-seamless-scroll>
              </ul>
            </div>
          </div>
        </div>
        <div class="pdwk-l-b">
          <div class="summary"><p>设备汇总值，汇总设备<a>{{ workAll.total }}</a>台，停机<a>{{workAll.down}}</a>台，正常运行<a>{{workAll.onLine}}</a>台</p></div>
          <div class="workshop">
            <div class="workshop-one">
              <ul>
                <li v-for="(item,index) in equipList.slice(11,22)" :class="item.isruning==0?'error-st':''" :key="item.equipmenid" @click="clickgetdtail(item.equipmenid,index+12)" :style="timer==index+12?'background: rgba(222,217,20,0.75);':''">
                  <div class="point-st">
                    <em class="halo"></em>
                    <i class="line" v-if="item.isruning==0"></i>
                    <div class="hint" v-if="item.isruning==0">
                      <p>{{ index+12 }}号缸</p>
                      <p>停{{ item.outtime }}分</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="workshop-two">
              <ul>
                <li v-for="(item,index) in equipList.slice(0,11)" :class="item.isruning==0?'error-st':''" :key="item.equipmenid" @click="clickgetdtail(item.equipmenid,index+1)" :style="timer==index+1?'background: rgba(222,217,20,0.75);':''">
                  <div class="point-st">
                    <em class="halo"></em>
                    <i class="line" v-if="item.isruning==0"></i>
                    <div class="hint" v-if="item.isruning==0">
                      <p>{{ index+1 }}号缸</p>
                      <p>停{{ item.outtime }}分</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="workshop-three">
              <ul>
                <li v-for="(item,index) in equipList.slice(22,34)" :class="item.isruning==0?'error-st':''" :key="item.equipmenid" @click="clickgetdtail(item.equipmenid,index+23)" :style="timer==index+23?'background: rgba(222,217,20,0.75);':''">
                  <div class="point-st">
                    <em class="halo"></em>
                    <i class="line" v-if="item.isruning==0"></i>
                    <div class="hint" v-if="item.isruning==0">
                      <p>{{ index+23 }}号缸</p>
                      <p>停{{ item.outtime }}分</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="workshop-four">
              <ul>
                <li v-for="(item,index) in equipList.slice(46,49)" :class="item.isruning==0?'error-st':''" :key="item.equipmenid" @click="clickgetdtail(item.equipmenid,index+47,1)" :style="timer==index+47?'background: rgba(222,217,20,0.75);':''">
                  <div class="point-st">
                    <em class="halo"></em>
                    <i class="line" v-if="item.isruning==0"></i>
                    <div class="hint" v-if="item.isruning==0">
                      <p>{{ index+3 }}号缸</p>
                      <p>停{{ item.outtime }}分</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="workshop-five">
              <ul>
                <li v-for="(item,index) in equipList.slice(44,46)" :class="item.isruning==0?'error-st':''" :key="item.equipmenid" @click="clickgetdtail(item.equipmenid,index+45,1)" :style="timer==index+45?'background: rgba(222,217,20,0.75);':''">
                  <div class="point-st">
                    <em class="halo"></em>
                    <i class="line" v-if="item.isruning==0"></i>
                    <div class="hint" v-if="item.isruning==0">
                      <p>{{ index+1 }}号缸</p>
                      <p>停{{ item.outtime }}分</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="workshop-six">
              <ul>
                <li v-for="(item,index) in equipList.slice(34,38)" :class="item.isruning==0?'error-st':''" :key="item.equipmenid" @click="clickgetdtail(item.equipmenid,index+35)" :style="timer==index+35?'background: rgba(222,217,20,0.75);':''">
                  <div class="point-st">
                    <em class="halo"></em>
                  </div>
                </li>
              </ul>
            </div>
            <div class="workshop-seven">
              <ul>
                <li v-for="(item,index) in equipList.slice(38,44)" :class="item.isruning==0?'error-st':''" :key="item.equipmenid" @click="clickgetdtail(item.equipmenid,index+39)" :style="timer==index+39?'background: rgba(222,217,20,0.75);':''">
                  <div class="point-st">
                    <em class="halo"></em>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="oee-s">
            <p><countTo :startVal='0' :endVal='workAll.equipOee' :decimals="1" :duration='8000'></countTo><em>%</em></p>
            <a>设备OEE</a>
          </div>
        </div>
      </div>
      <div class="pdwk-r">
        <div class="device-info" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.3)">
          <div class="device-info-title">{{ workDetail.equipInfoOne.machinename | transcoding }}运行情况<i class="run-st" :class="workDetail.equipInfoOne.isruning>0?'':'run-st-error'"></i></div>
          <div class="device-infos device-info-one" v-if="ty==0">
            <div class="point-st" :class="workDetail.clothList[0].status>0?'error-st':''">
              <em class="halo"></em>
              <i class="line"></i>
              <div class="hint">
                <p>布头周期：{{ workDetail.clothList[0].cycle||'--' }}秒</p>
                <p>布头圈数：{{ workDetail.clothList[0].ringnum||'--' }}圈</p>
              </div>
            </div>
            <div class="point-st" :class="workDetail.clothList[1].status>0?'error-st':''">
              <em class="halo"></em>
              <i class="line"></i>
              <div class="hint">
                <p>布头周期：{{ workDetail.clothList[1].cycle||'--' }}秒</p>
                <p>布头圈数：{{ workDetail.clothList[1].ringnum||'--' }}圈</p>
              </div>
            </div>
            <div class="point-st">
              <em class="halo"></em>
              <i class="line"></i>
              <div class="hint">
                <p>当前步骤：{{ workDetail.equipInfoOne.stepname||'' }}</p>
                <p>当前工步/总步数：{{ workDetail.equipInfoOne.stepnumber ||'--' }}/{{ workDetail.equipInfoOne.planstepnum ||'--' }}</p>
              </div>
            </div>
            <div class="point-st">
              <em class="halo"></em>
              <i class="line"></i>
              <div class="hint">
                <p>温度：{{ workDetail.equipInfoOne.temperature||'--' }}℃</p>
              </div>
            </div>
            <div class="point-st">
              <em class="halo"></em>
              <i class="line"></i>
              <div class="hint">
                <p>水位：{{ workDetail.equipInfoOne.waterlevel||'--' }}mm</p>
              </div>
            </div>
          </div>
          <div class="device-infos device-info-two" v-else>
            <div class="point-st" style="top: 152px;left: 42px;"><em class="halo"></em><i class="line" style="transform: rotate(-190deg); height: 56px"></i><div class="hint" style="top: -80px; left: -10px"><p>下超喂:{{ equipInfoTwo.xcw ||'--' }}</p></div></div>
            <div class="point-st" style="top: 142px;left: 52px;"><em class="halo"></em><i class="line" style="transform: rotate(-180deg); height: 120px"></i><div class="hint" style="top: -146px; left: 10px"><p>进气压力:{{ equipInfoTwo.jqy ||'--' }}kpa(千帕) </p></div></div>
            <div class="point-st" style="top: 148px;left: 60px;"><em class="halo"></em><i class="line" style="transform: rotate(-153deg); height: 180px"></i><div class="hint" style="top: -187px; left: 78px"><p>上针超喂：{{ equipInfoTwo.szcw ||'--' }}</p></div></div>
            <div class="point-st" style="top: 160px;left: 62px;"><em class="halo"></em><i class="line" style="transform: rotate(40deg); height: 30px"></i><div class="hint" style="top: 24px; left: -20px"><p>前门幅：{{ equipInfoTwo.qmf ||'--' }}</p></div></div>
            <div class="point-st" style="top: 140px;left: 92px;"><em class="halo"></em><i class="line" style="transform: rotate(-150deg); height: 70px"></i><div class="hint" style="top: -87px; left: 50px"><p>上超喂：{{ equipInfoTwo.scw ||'--' }}</p></div></div>
            <!-- 下排内容-->
            <div class="point-st" style="top: 180px;left: 112px;"><em class="halo"></em><i class="line" style="transform: rotate(60deg); height: 80px"></i><div class="hint" style="top: 40px; left: -60px"><p>循环风机转速1：{{ equipInfoTwo.xfan1 ||'--' }}转</p></div></div>
            <div class="point-st" style="top: 190px;left: 157px;"><em class="halo"></em><i class="line" style="transform: rotate(40deg); height: 80px"></i><div class="hint" style="top: 63px; left: -55px"><p>循环风机转速2：{{ equipInfoTwo.xfan2 ||'--' }}转</p></div></div>
            <div class="point-st" style="top: 206px;left: 206px;"><em class="halo"></em><i class="line" style="transform: rotate(40deg); height: 104px"></i><div class="hint" style="top: 80px; left: -55px"><p>循环风机转速3：{{ equipInfoTwo.xfan3 ||'--' }}转</p></div></div>
            <div class="point-st" style="top: 222px;left: 260px;"><em class="halo"></em><i class="line" style="transform: rotate(20deg); height: 105px"></i><div class="hint" style="top: 96px; left: -55px"><p>循环风机转速4：{{ equipInfoTwo.xfan4 ||'--' }}转</p></div></div>
            <div class="point-st" style="top: 234px;left: 316px;"><em class="halo"></em><i class="line" style="transform: rotate(-5deg); height: 118px"></i><div class="hint" style="top: 117px; left: -5px"><p>循环风机转速5：{{ equipInfoTwo.xfan5 ||'--' }}转</p></div></div>
            <div class="point-st" style="top: 252px;left: 381px;"><em class="halo"></em><i class="line" style="transform: rotate(-10deg); height: 60px"></i><div class="hint" style="top: 60px;"><p>循环风机转速6：{{ equipInfoTwo.xfan6 ||'--' }}转</p></div></div>
            <div class="point-st" style="top: 273px;left: 462px;"><em class="halo"></em><i class="line" style="transform: rotate(-5deg); height: 98px"></i><div class="hint" style="top: 92px; left: 12px"><p>循环风机转速7：{{ equipInfoTwo.xfan7 ||'--' }}转</p></div></div>
            <div class="point-st" style="top: 297px;left: 548px;"><em class="halo"></em><i class="line" style="transform: rotate(-15deg); height: 98px"></i><div class="hint" style="top: 98px; left: 18px"><p>循环风机转速8：{{ equipInfoTwo.xfan8 ||'--' }}转</p></div></div>
            <div class="point-st" style="top: 326px;left: 636px;"><em class="halo"></em><i class="line" style="transform: rotate(-20deg); height: 105px"></i><div class="hint" style="top: 100px; left: 40px"><p>循环风机转速9：{{ equipInfoTwo.xfan9 ||'--' }}转</p></div></div>
            <!-- 上排内容-->
            <div class="point-st" style="top: 165px;left: 120px;"><em class="halo"></em><i class="line" style="transform: rotate(-129deg); height: 60px"></i><div class="hint" style="top: -62px; left: 60px"><p>PV1：{{ equipInfoTwo.pv1 ||'--' }}℃</p></div></div>
            <div class="point-st" style="top: 174px;left: 160px;"><em class="halo"></em><i class="line" style="transform: rotate(-138deg); height: 100px"></i><div class="hint" style="top: -100px; left: 70px"><p>PV2：{{ equipInfoTwo.pv2 ||'--' }}℃</p></div></div>
            <div class="point-st" style="top: 180px;left: 182px;"><em class="halo"></em><i class="line" style="transform: rotate(-135deg); height: 154px"></i><div class="hint" style="top: -137px; left: 110px"><p>排风转速1：{{ equipInfoTwo.pfan1 ||'--' }}转</p></div></div>
            <div class="point-st" style="top: 188px;left: 206px;"><em class="halo"></em><i class="line" style="transform: rotate(-115deg); height: 78px"></i><div class="hint" style="top: -60px; left: 80px"><p>PV3：{{ equipInfoTwo.pv3 ||'--' }}℃</p></div></div>
            <div class="point-st" style="top: 202px;left: 255px;"><em class="halo"></em><i class="line" style="transform: rotate(-138deg); height: 106px"></i><div class="hint" style="top: -105px; left: 90px"><p>PV4：{{ equipInfoTwo.pv4 ||'--' }}℃</p></div></div>
            <div class="point-st" style="top: 212px;left: 290px;"><em class="halo"></em><i class="line" style="transform: rotate(-135deg); height: 168px"></i><div class="hint" style="top: -145px; left: 120px"><p>排风转速2：{{ equipInfoTwo.pfan2 ||'--' }}转</p></div></div>
            <div class="point-st" style="top: 218px;left: 312px;"><em class="halo"></em><i class="line" style="transform: rotate(-122deg); height: 80px"></i><div class="hint" style="top: -66px; left: 90px"><p>PV5：{{ equipInfoTwo.pv5 ||'--' }}℃</p></div></div>
            <div class="point-st" style="top: 230px;left: 375px;"><em class="halo"></em><i class="line" style="transform: rotate(-131deg); height: 124px"></i><div class="hint" style="top: -107px; left: 95px"><p>PV6：{{ equipInfoTwo.pv6 ||'--' }}℃</p></div></div>
            <div class="point-st" style="top: 242px;left: 420px;"><em class="halo"></em><i class="line" style="transform: rotate(-130deg); height: 190px"></i><div class="hint" style="top: -149px; left: 150px"><p>排风转速3：{{ equipInfoTwo.pfan3 ||'--' }}转</p></div></div>
            <div class="point-st" style="top: 250px;left: 450px;"><em class="halo"></em><i class="line" style="transform: rotate(-125deg); height: 125px"></i><div class="hint" style="top: -96px; left: 100px"><p>PV7：{{ equipInfoTwo.pv7 ||'--' }}℃</p></div></div>
            <div class="point-st" style="top: 263px;left: 501px;"><em class="halo"></em><i class="line" style="transform: rotate(-127deg); height: 190px"></i><div class="hint" style="top: -140px; left: 160px"><p>排风转速4：{{ equipInfoTwo.pfan4 ||'--' }}转</p></div></div>
            <div class="point-st" style="top: 272px;left: 535px;"><em class="halo"></em><i class="line" style="transform: rotate(-130deg); height: 84px"></i><div class="hint" style="top: -82px; left: 70px"><p>PV8：{{ equipInfoTwo.pv8 ||'--' }}℃</p></div></div>
            <div class="point-st" style="top: 290px;left: 596px;"><em class="halo"></em><i class="line" style="transform: rotate(-135deg); height: 150px"></i><div class="hint" style="top: -132px; left: 115px"><p>排风转速5：{{ equipInfoTwo.pfan5 ||'--' }}转</p></div></div>
            <div class="point-st" style="top: 302px;left: 635px;"><em class="halo"></em><i class="line" style="transform: rotate(-130deg); height: 114px"></i><div class="hint" style="top: -100px; left: 85px"><p>PV9：{{ equipInfoTwo.pv9 ||'--' }}℃</p></div></div>
            <!-- 出布内容-->
            <div class="point-st" style="top: 332px;left: 735px;"><em class="halo"></em><i class="line" style="transform: rotate(-40deg); height: 82px"></i><div class="hint" style="top: 62px; left: 60px"><p>后门幅：{{ equipInfoTwo.hmf ||'--' }}毫米</p></div></div>
            <div class="point-st" style="top: 352px;left: 785px;"><em class="halo"></em><i class="line" style="height: 80px"></i><div class="hint" style="top: -105px; "><p>出布超喂:无</p></div></div>
            <div class="point-st" style="top: 302px;left: 815px;"><em class="halo"></em><i class="line" style="height: 152px"></i><div class="hint" style="top: -175px; "><p>冷水辊超喂：{{ equipInfoTwo.lsgcw ||'--' }}</p></div></div>
            <div class="point-st" style="top: 286px;left: 885px;"><em class="halo"></em><i class="line" style="height: 78px"></i><div class="hint" style="top: -95px; "><p>落布超喂：{{ equipInfoTwo.lbcw ||'--' }}</p></div></div>
            <div class="point-st" style="top: 286px;left: 635px; background: none;"><div class="hint" style="top: -265px; "><p>当前车数：{{ equipInfoTwo.cs?equipInfoTwo.cs.toFixed(2):'--' }}米/分钟</p></div></div>
            <div class="point-st" style="top: 286px;left: 795px; background: none;"><div class="hint" style="top: -265px; "><p>总门幅：{{ equipInfoTwo.zmf||'--' }}毫米</p></div></div>
          </div>
        </div>
        <div class="device-info-st" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.3)">
          <div style="width: 175px" :class="workDetail.equipInfoOne.isruning>0?'':'breathing'">
            <h2 style="width: 100%;text-align: center">{{workDetail.equipInfoOne.isruning>0?'正常运行':'停机'}}</h2>
            <p v-if="workDetail.equipInfoOne.isruning==0"><span style="font-size: 24px">{{ workDetail.equipInfoOne.outtime }}分钟</span></p>
          </div>
          <div style="width: 265px">
            <h3 style="text-align: center;padding-top: 4px">当前订单</h3>
            <p style="margin-top: 3px"><span style="width: 100px; display: inline-block; text-align: right">开始时间：</span>{{ workDetail.equipInfoOne.createtime | parseTimes}}</p>
            <p style="margin-top: 2px"><span style="width: 100px; display: inline-block; text-align: right">颜色：</span>{{ workDetail.equipInfoOne.groundcolor }}</p>
          </div>
          <div style="width: 525px">
            <p style="padding-top: 18px"><span style="width: 90px; display: inline-block; text-align: right; line-height: 21px">总进度：</span><em class="skill-line"><i :style="{width:calculate(workDetail.equipInfoOne)+'%'}">{{ workDetail.equipInfoOne| percentage}}% </i></em> {{workDetail.equipInfoOne.plantime||0}}/<span :style="workDetail.equipInfoOne.runtime<0?'color:red':''">{{(workDetail.equipInfoOne.runtime<0?'超'+workDetail.equipInfoOne.runtime*-1:workDetail.equipInfoOne.runtime)||0}}</span></p>
            <p style="margin-top: 5px"><span style="width: 90px; display: inline-block; text-align: right">订字：</span>{{ workDetail.equipInfoOne.contractnumber }}</p>
          </div>
        </div>
        <div class="device-info-oee clear">
          <span v-for="(item,index) in workDetail.oeeList" :key="index">{{ item.hour<10?'0'+item.hour: item.hour}}<em :class="item.isrun>0?'':'error'"><i class="iconfont" :class="item.isrun>0?'icon-duihao':'icon-cuo'"></i></em></span>
          <span style="width: 76px;line-height: 120%"><a style="font-size: 12px;">综合效率</a><br><b>{{ workDetail.efficiency }}%</b></span>
        </div>
        <div class="device-info-temperature" id="echart_temperature" v-if="showline"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AccountInfo from '../layout/account-info';
import Echartring from "../../components/echart-ring"
import countTo from 'vue-count-to'
import {debounce} from '../../bll/utils'
import pinyin from 'js-pinyin'
pinyin.setOptions({checkPolyphone:false,chartCase:0})
export default {
  name: 'Pdworkshop',
  components:{
    AccountInfo,
    Echartring,
    countTo
  },
  props: {
    dataRefresh: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  filters: {
    maintenances(status){
      let name=''
      switch(status*1) {
        case 0:
          name='未派单'
          break;
        case 1:
          name='已派单'
          break;
        case 2:
          name='正在处理'
          break;
        case 3:
          name='已结单'
          break;
        default:
          name='未接收'
      }
      return name
    },
    parseTimes(t){
      return t?t.replace("T"," "):''
    },
    percentage(wd){
      let pd=0
      if(wd.plantime&&wd.plantime*1!=0){
        pd=Math.round((wd.plantime-wd.runtime)*100/wd.plantime)
      }
      // this.widths=pd>100?100:pd
      return pd>100?100:pd
    },
    transcoding(name){
      return pinyin.getCamelChars(name)
    }
  },
  data () {
    return {
      headtitle:'印染数智车间',
      kls:false,
      loading:true,
      permissions:[1],
      myconfigring4:{
        id:'num4',
        text:'本月车间能耗',
        seriesleft:'23%',
        seriesdata:[],
        name:'本月车间能耗'
      },
      deviceid:'',
      timer:1,
      showline:true,
      ty:0,
      getdatasid:'',
      workAll: {
        equipOee:0,
      },
      equipList:[],
      workDetail:{
        clothList:[{
          cycle:'',
          ringnum:'',
          status:''
        },{
          cycle:'',
          ringnum:'',
          status:''
        }],
        equipInfoOne:{
          stepname:'',
          temperature:'',
          stepnumber:'',
          planstepnum:'',
          waterLevel:'',
          groundcolor:'',
          createtime:'',
          contractnumber:'',
          isruning:1,
          machinename:''
        }
      },
      equipInfoTwo:{},
      $_resizeHandler:null,
      $_timergetdata:null,
      widths:''
    }
  },
  computed:{
    classOption(){
      return{
        step:0.2,// 数值越大速度滚动越快
        limitMoveNum:2,// 开始无缝滚动的数据量 this.dataList.length
        hoverStop:true,// 是否开启鼠标悬停stop
        direction:1,// 0向下 1向上 2向左 3向右
        openWatch:true,// 开启数据实时监控刷新dom
        singleHeight:0,// 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth:0,// 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime:1000,// 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  created () {
    localStorage.setItem('gotourl', window.location.hash)
  },
  mounted(){
    const $this=this
    setTimeout(function () {
      $this.getdata()
    },500)
    this.$_resizeHandler = debounce(() => {
      this.getworkdetail()
    }, 1000)
    $this.dataRefresh.$ons('Refresh',()=>{
      $this.workAll={
        equipOee:0,
      }
      $this.getdata()
    })
  },
  methods:{
    getdata(){
      const url = '/api-portal/work/workAll';
      const $this=this
      this.$api.get(url, {}, (response) => {
        let datas=response.data||''
        if(datas){
          $this.workAll=datas.data
          $this.equipList=datas.data.equipList
          $this.myconfigring4.seriesdata=(datas.data.monthEnergy).map(val=>{
            return {name:val.name,value:val.value}
          })
          $this.$refs.myconfigring4.echartring()
          // $this.getworkdetail(datas.data.equipList[0].equipmenid)
          $this.getdatasid=datas.data.equipList[0].equipmenid
          $this.getworkdetail()
        }
      })
      $this.$_timergetdata=setInterval(function (){
        if($this.timer>=49){
          $this.timer = 0
        }
        $this.timer+=1
        $this.getdatasid=$this.equipList[$this.timer-1].equipmenid
        $this.ty=$this.timer>=45?1:0
        $this.$_resizeHandler()
      },90000)
    },
    calculate(dw){
      return this.$options.filters['percentage'](dw)
    },
    clickgetdtail(id,num,ty){
      if(id!=this.getdatasid){
        this.getdatasid=id
        this.timer=num
        this.ty=ty?ty:0
        this.$_resizeHandler()
      }
    },
    getworkdetail(){
      const $this=this
      const url1 = '/api-portal/work/workDetail';
      this.loading=true
      this.$api.get(url1, {equipId: $this.getdatasid}, (response) => {
        let datas=response.data||''
        if(datas){
          $this.workDetail=datas.data
          const noline =datas.data.tempList||[]
          if(noline.length>0){
            $this.showline=true
            setTimeout(function () {
              $this.drawlinediagram(noline)
            },500)
          }else {
            $this.showline=false
          }
          if(datas.data.equipInfoTwo){
            $this.equipInfoTwo = datas.data.equipInfoTwo
          }
        }
        this.loading=false
      })
    },
    drawlinediagram(datas){
      const myEchartst = this.$echarts.init(document.getElementById('echart_temperature'))
      let option = {
        tooltip: {
          trigger: 'axis',
          formatter:function (params) {
            let str = '';
            str += params[0].data.timepoint+'<br/>'
            str += `${params[0].marker}${params[0].seriesName}: ${params[0].value} ℃`
            return str
          }
        },
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '12%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            color: '#C1D3F4'
          },
          axisLine:{
            lineStyle:{
              color:'#5788EC'
            }
          },
          // data: date
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          max:function (value) {
            return value.max
          },
          interval:15,
          splitLine: {
            lineStyle: {
              color: '#2345AB'
            }
          },
          axisLine:{
            show:true,
            lineStyle:{
              color:'#5788EC'
            }
          },
          axisLabel: {
            color: '#C1D3F4'
          }
        },
        series: [
          {
            name: '设备温度',
            type: 'line',
            symbol: 'none',
            sampling: 'lttb',
            itemStyle: {
              color: 'rgb(255, 70, 131)'
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgb(255, 158, 68)'
                },
                {
                  offset: 1,
                  color: 'rgb(255, 70, 131)'
                }
              ])
            },
            data: datas
          }
        ]
      }
      myEchartst.setOption(option)
    }
  },
  beforeDestroy () {
    const $this = this
    clearInterval($this.$_timergetdata)
    $this.$_timergetdata = null
  }
}
</script>

<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 1080px;
  overflow: auto;
  background: #001346 url("../../assets/secondary/bg-4.png") no-repeat center bottom;
}
.head-wh{
  height: 147px;
  background: url("../../assets/secondary/title.png") no-repeat center top;
}
.title-center{
  font-size: 36px;
  font-family:"fzskjt";
  color: #D2DFFF;
  font-style: italic;
  padding-top: 15px;
  text-shadow: 3px 2px 7px rgba(0,0,0,0.65);
  line-height: 200%;
  text-align: center;
}

.secondary-content{
  width: 100%;
  height: calc(100% - 90px);
  margin-top: -57px;
  padding: 0 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pdwk-r{
  width: 1033px;
  height: 990px;
  margin-top: -18px;
  background: url("../../assets/secondary/border-7.png") no-repeat center top;
}

.pdwk-l-t{
  width: 849px;
  height: 274px;
  margin-left: 19px;
  background: url("../../assets/secondary/border-3.png") no-repeat center/100%;
}

.pdwk-l-b{
  width: 887px;
  height: 727px;
  margin-top: -12px;
  padding-top: 20px;
  box-sizing: border-box;
  background: url("../../assets/secondary/border-4.png") no-repeat center bottom;
}

.clinch-deal-list{
  padding: 10px 16px 10px 12px;
  color: #fff;
  font-size: 14px;
}

.clinch-deal-list p,.clinch-deal-list li{
  display: flex;
  justify-content: space-between;
}

.clinch-deal-list p{
  border-bottom: 1px solid #1E60B9;
  padding-bottom: 8px;
}

.clinch-deal-list li{
  height: 38px;
  line-height: 38px;
  font-size: 12px;
  background: rgba(47,62,183,0.9);
}

.clinch-deal-list li:nth-child(even){
  background: rgba(20,36,108,0.9);
}

.clinch-deal-list ul{
  height: 180px;
  overflow: hidden;
}

.clinch-deal-list span{
  text-align: left;
  display: inline-block;
  overflow:hidden;
  white-space: nowrap;
  text-overflow:ellipsis;
  flex: 1;
}

.clinch-deal-list em{
  width: 21px;
  height: 21px;
  border-radius: 50%;
  border: 1px solid #04357D;
  background: #0544A3;
  text-align: center;
  font-style: normal;
  line-height: 21px;
  display: inline-block;
  box-shadow: 1px 2px 2px rgba(0,0,0,0.35);
}

.clinch-deal-list span:first-child{
  width: 40px;
  flex: none;
  text-align: center;
}

.clinch-deal-list span:nth-child(1){
  width: 80px;
}

.clinch-deal-list span:nth-child(2){
  width: 80px;
}

.clinch-deal-list span:nth-child(3){
  width: 80px;
}

.summary{
  width: 716px;
  height: 85px;
  background: url("../../assets/secondary/border-5.png") no-repeat center/100%;
  margin: 0 auto;
  color: #fff;
  font-family: fzskjt;
  font-size: 21px;
  line-height: 85px;
  text-align: center;
}

.summary p{
  background: linear-gradient(to bottom, #fff, #fff,#8EFFFF,#fff, #fff);
  -webkit-background-clip:text;
  color:transparent;
}

.summary a{
  font-size: 32px;
}

.workshop{
  width: 803px;
  height: 434px;
  margin-left: 20px;
  margin-top: 32px;
  position: relative;
  background: url("../../assets/secondary/pdws.png") no-repeat center/100%;
}

.workshop ul{
  height: 100%;
  width: 100%;
}

.workshop li{
  position: relative;
  border-radius: 6px;
  cursor: pointer;
  /*background: rgba(154,125,25,0.75);*/
  display: flex;
  justify-content: center;
  align-items: center;
}

.workshop-one{
  width: 220px;
  height: 29px;
  position: absolute;
  top: 54px;
  left: 207px;
}

.workshop-one li{
  width: 15px;
  height: 100%;
  margin-right: 3px;
  margin-left: 1.9px;
  float: left;
  transform:skewX(-23deg);
}

.workshop-two{
  width: 273px;
  height: 49px;
  position: absolute;
  top: 232px;
  left: 115px;
  padding-left: 8px;
  box-sizing: border-box;
}

.workshop-two li{
  width: 15px;
  height: 100%;
  margin-right: 6.5px;
  margin-left: 2.4px;
  float: left;
  transform:skewX(-15deg);
}

.workshop-three{
  width: 260px;
  height: 34px;
  position: absolute;
  top: 124px;
  left: 462px;
}

.workshop-three li{
  width: 15px;
  height: 100%;
  margin-right: 4.5px;
  margin-left: 2px;
  float: left;
  transform:skewX(-1deg);
}

.workshop-four{
  width: 218px;
  height: 140px;
  position: absolute;
  top: 263px;
  left: 496px;
}

.workshop-four li{
  width: 100%;
  height: 25px;
}

.workshop-four li:nth-child(2){
  margin-top: 30px;
}

.workshop-four li:nth-child(3){
  margin-top: 34px;
}

.workshop-five{
  width: 172px;
  height: 54px;
  position: absolute;
  top: 48px;
  left: 528px;
}

.workshop-five li{
  width: 100%;
  height: 20px;
}

.workshop-five li:nth-child(2){
  margin-top: 15px;
}

.workshop-six{
  width: 230px;
  height: 29px;
  position: absolute;
  top: 129px;
  left: 175px;
}

.workshop-six li{
  width: 30px;
  height: 100%;
  margin-right: 27px;
  margin-left: 2px;
  float: left;
  transform:skewX(-10deg);
}

.workshop-six li:nth-child(4){
  margin-right: 0px;
  margin-left: 8px;
}

.workshop-seven{
  width: 216px;
  height: 75px;
  position: absolute;
  top: 328px;
  left: 114px;
}

.workshop-seven li{
  width: 35px;
  height: 43%;
  margin-top: 7px;
  margin-right: 44px;
  margin-left: 2px;
  float: left;
  transform:skewX(-10deg);
}

.workshop-seven li:nth-child(3),.workshop-seven li:nth-child(6){
  margin-right: 0px;
  margin-left: 0px;
}

.workshop-seven li:nth-child(4){
  margin-left: -6px;
}

.oee-s{
  width: 227px;
  height: 120px;
  margin: 0 auto;
  margin-top: 23px;
  padding-top: 55px;
  box-sizing: border-box;
  background: url("../../assets/secondary/border-6.png") no-repeat center/100%;
  text-align: center;
}

.oee-s span{
  font-size: 38px;
  color: #FFC926;
  font-weight: bold;
  font-family: Bahnschrift;
  text-shadow: 3px 2px 7px rgba(0,0,0,0.65);
}

.oee-s em{
  font-size: 16px;
  color: #FFC926;
  font-family: Arial;
}

.oee-s a{
  font-size: 16px;
  margin-top: -8px;
  color: #D2E4FE;
  display: block;
}

.point-st{
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #0f0;
  position: relative;
}

.workshop-one .point-st{
  transform:skewX(23deg);
}

.workshop-two .point-st{
  transform:skewX(15deg);
}
.workshop-six .point-st{
  transform:skewX(10deg);
}
.workshop-three .point-st{
  transform:skewX(1deg);
}

.halo{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #0f0;
  animation: flicker_halo 1.5s infinite
}

.line{
  width: 5px;
  height: 32px;
  border-left: 1px solid rgb(220, 20, 60);
  position: absolute;
  top: 1px;
  left: 3px;
  transform: translate(-50%,-50%);
  transform: rotate(-195deg);
  transform-origin: left top
}

.hint{
  position: absolute;
  left: -10px;
  top: -70px;
  transform:translateX(-50%);
  padding: 3px 2px;
  border: 1px solid rgb(220, 20, 60);
  background-color: rgba(220, 20, 60, 0.35);
  display: inline-block;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 20;
  color: #fff;
}

.workshop li:nth-child(even) .line{
  height: 53px;
  top: 2px;
  transform: rotate(60deg);
}

.workshop li:nth-child(even) .hint{
  left: -50px;
  top: 28px;
}

.workshop-five li:nth-child(2) .line,.workshop-four li:nth-child(2) .line{
  height: 42px;
  top: 2px;
  transform: rotate(-125deg);
}
.workshop-five li:nth-child(2) .hint,.workshop-four li:nth-child(2) .hint{
  left: 50px;
  top: -62px;
}

.error-st .point-st{
  background: #FF0229;
}
.error-st .halo{
  background: #FF0229;
}

.device-info{
  width: 100%;
  height: 590px;
}

.device-info-title{
  width: 365px;
  height: 103px;
  padding-top: 9px;
  background: url("../../assets/secondary/border-8.png") no-repeat center bottom;
  margin: 0 auto;
  font-size: 26px;
  color: #fff;
  font-weight: bold;
  line-height: 92px;
  text-align: center;
  position: relative;
}

.run-st{
  width: 103px;
  height: 8px;
  background: url("../../assets/secondary/bj-5.png") no-repeat 0 0;
  position: absolute;
  left: 50%;
  margin-left: -51px;
  bottom: 6px;
  animation: flicker_run-st 1s infinite
}

.run-st-error{
  background-position: 0 -7px;
}

.device-infos{
  width: 980px;
  height: 453px;
  margin-left: 21px;
  margin-top: 22px;
  border-bottom: 2px solid #D5CFCE;
  position: relative;
}

.device-info-one{
  background: url("../../assets/secondary/device-1.png") no-repeat center bottom;
}

.device-info-two{
  background: url("../../assets/secondary/device-2.png") no-repeat center bottom;
}

.device-info .point-st{
  position: absolute;
  background: #A8CCFD;
}

.device-info .halo{
  width: 8px;
  height: 8px;
  background: #4DD2FF;
}

.device-info .line{
  border-left: 1px solid #468DF9;
  width: 0px;
  height: 130px;
  left: 3px;
  border-right: 1px solid rgba(0,0,0,0.15);
  transform: rotate(-180deg);
}

.device-info .hint{
  border: 1px solid #3584F9;
  font-size: 14px;
  left: 0px;
  background-color: rgba(8, 91, 215, 0.45);
  box-shadow: 2px 4px 6px rgba(0,0,0,0.35);
  top:-170px;
}

.device-info-one .hint{
  padding: 4px 8px;
}

.device-info-two .hint{
  padding: 3px 4px;
}

.device-info .error-st .halo{
  background: #FF0229;
}

.device-info .error-st .line{
  border-left: 1px solid #FF0229;
}

.device-info .error-st .hint{
  background-color: rgba(220, 20, 60, 0.45);
  border: 1px solid #FF0229;
}

.device-info-one .point-st:nth-child(1){
  top:176px;
  left: 285px;
}

.device-info-one .point-st:nth-child(1) .line{
  transform: rotate(60deg);
  height: 170px;
}

.device-info-one .point-st:nth-child(1) .hint{
  top:86px;
  left: -160px;
}

.device-info-one .point-st:nth-child(2){
  top:184px;
  left: 385px;
}

.device-info-one .point-st:nth-child(2) .line{
  transform: rotate(50deg);
  height: 170px;
}

.device-info-one .point-st:nth-child(2) .hint{
  top:112px;
  left: -130px;
}

.device-info-one .point-st:nth-child(3){
  top:234px;
  left: 565px;
}

.device-info-one .point-st:nth-child(4){
  top:170px;
  left: 685px;
}

.device-info-one .point-st:nth-child(4) .hint,.device-info-one .point-st:nth-child(5) .hint{
  top:-155px;
}

.device-info-one .point-st:nth-child(5){
  top:190px;
  left: 810px;
}

.device-info-temperature{
  height: 240px;
}

.device-info-st{
  width: 100%;
  height: 87px;
  display: flex;
  padding: 0 12px 0 21px;
  box-sizing: border-box;
  justify-content: space-between;
  color: #fff;
}

.device-info-st>div{
  border: 1px solid #4B74ED;
  background: #0D2A81;
}

.device-info-st>div:nth-child(1){
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.breathing{
  color: #FF3314;
  animation: flicker_breathing 1s infinite
}

.device-info-oee{
  height: 42px;
  color: #fff;
  padding: 0 12px 0 21px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}

.device-info-oee span{
  width: 36px;
  background: #2848C1;
  line-height: 160%;
  height: 100%;
  text-align: center;
}

.device-info-oee em{
  display: block;
  height: 15px;
  line-height: 15px;
  background: #27D40A;
  color: #164A6F;
  padding: 0;
  border: none;
  margin: 0;
}

.device-info-oee em.error{
  background: #EC1C00;
}

.skill-line{
  display: inline-block;
  width: 340px;
  height: 21px;
  background:#0531B4;
  border-radius: 5px;
}

.skill-line i{
  height: 100%;
  display: inline-block;
  text-align: right;
  line-height: 21px;
  font-style: normal;
  background: linear-gradient(to right,#154EF7,#288BE8);
  padding-right: 3px;
  box-sizing: border-box;
  border-radius: 5px;
  position: relative;
}

.skill-line i:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #fff;
  border-radius: 10px;
  opacity: 0;
  animation: active3_4 3.4s cubic-bezier(.43,1,.52,1) infinite;
  content: " "
}

@keyframes flicker_halo {
  0% {
    transform: scale(1);
    opacity: .9
  }

  to {
    transform: scale(5);
    opacity: .0
  }
}

@keyframes flicker_run-st {
  0% {
    transform: scale(0.7);
    opacity: 1
  }

  to {
    transform: scale(1.1);
    opacity: .8
  }
}

@keyframes flicker_breathing {
  0% {
    opacity: 1
  }
  70%{
    opacity: 0.6
  }
  to {
    opacity: .9
  }
}

@keyframes active3_4 {
  0% {
    width: 0;
    opacity: .1
  }

  20% {
    width: 0;
    opacity: .5
  }

  to {
    width: 100%;
    opacity: 0
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Ld-screen/Pd-workshop.vue